module.exports = __webpack_public_path__ + "img/signIcon.ef28a00d.png";